
import {Component, Vue} from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {IAddShippingModel, ICustomerModel, IUserModel} from "@/api/types";
import {getUsersByJobPosition} from "@/api/users";
import {Message} from "element-ui";
import {defaultCustomerData, searchCustomer} from "@/api/customer";
import {FactoryLoadingPlan} from "@/model/FactoryLoadingPlan";
import {CustomsInfo} from "@/model/FinancialBookingModels";
import ContainerTypeReleasedInfo from "@/views/components/ContainerTypeReleasedInfo.vue";
import {saveContainerType} from "@/api/shipping-order";
import FactoryLoadingPlanHqPackingListInfoTable from "@/views/components/FactoryLoadingPlanHqPackingListInfoTable.vue";
import {ShippingOrderModel} from "@/model/shipping-order";
import {exportJson2Excel} from "@/utils/excel";
import {formatJson} from "@/utils";
import {
  BookingOrderProcessStage,
  Company,
  CompanyType,
  DeclarationState,
  ForwardingCharge,
  ForwardingChargeType,
} from "@/model/booking-order";
import {INTERNATIONAL_TRADE_TERMS, LADING_TYPE, PAYMENT_TYPE,} from "@/constant";
import DeclarationDocumentTable, {LoadingPlanListTableRowData,} from "@/views/components/DeclarationDocumentTable.vue";
import {
  createForwardingCompaniesInvoice,
  createLoadingPlanList,
  declare,
  deleteForwardingCompanies,
  deleteForwardingCompanyInvoice,
  deleteQingGuanList,
  downloadInvoiceTemplate, downloadShippingOrder,
  getCustomerPackingList,
  getCustomsDetails,
  getDocumentsList,
  getForwardingCharge,
  getForwardingCompanies,
  getLoadingPlanListDetail,
  getLoadingPlanLists,
  listProcessStages,
  listSpecialChargeTypes,
  newShippingOrder,
  queryDeclarationInfo,
  queryForwardingCompaniesInvoiceById,
  searchBookingOrderForLogistics,
  updateBookingOrder,
  updateDeadlineDate,
  updateDeclarationInfo,
  updateForwardingCharge,
  updateForwardingCompanies,
  updateLoadingPlanList,
  updateSailingSchedule,
  uploadDocuments,
} from "@/api/booking-order";
import ContainerLoadingInfoComponent, {
  ContainerLoadingInfoData,
  LoadingPlanInfo,
} from "@/views/components/ContainerLoadingInfoComponent.vue";
import {PackingVolume, ProblemType, State,} from "@/model/HenganLoadingPlanModels";
import {CustomsPackingCode} from "@/model/HqPackingListModels";

import {timeParser} from "@/filters";
import CustomsDeclarationDialog from "@/views/components/CustomsDeclarationDialog.vue";
import {deepClone} from "@/utils/deepClone";
import Template from "@/views/system-management/template/index.vue";
import {queryMarkLetter} from "@/api/purchase-order";
import DeclarationInfoConfirm from "@/views/components/bookingorder/DeclarationInfoConfirm.vue";
import DeclDocument from "@/views/customs-management/decl-document/DeclDocument.vue";
import UpdateMark from "@/views/customs-management/edit/mark.vue";
import ForwardCompanyInvoiceAudit from "@/views/customs-management/component/ForwardCompanyInvoiceAudit.vue";

@Component({
  name: "bookingOrders",
  components: {
    ForwardCompanyInvoiceAudit,
    DeclarationInfoConfirm,
    UpdateMark,
    DeclDocument,
    Template,
    ContainerLoadingInfoComponent,
    DeclarationDocumentTable,
    FactoryLoadingPlanHqPackingListInfoTable,
    ContainerTypeReleasedInfo,
    Pagination,
    CustomsDeclarationDialog,
  },
  methods: {
    PAYMENT_TYPE,
    INTERNATIONAL_TRADE_TERMS,
    LADING_TYPE,
  },
})
export default class extends Vue {
  private tableKey = 0;
  private total = 0;
  private listLoading = false;
  private showFileList = false;
  private files: File[] = [];
  private QingGuanZiLiaoShow = false;
  private textMap = {
    create: "新增报关合同",
    update: "编辑报关合同",
    addShippingOrder: "添加舱单",
    releaseContainerType: "分配柜型",
  };
  private JobPositionType = {
    seller: "seller",
    logisticsClerk: "logistics-clerk",
  };
  private sellerList: IUserModel[] = [];
  private logisticsClerkList: IUserModel[] = [];
  private shippingOrderList: IAddShippingModel[] = [];
  private payload = new FactoryLoadingPlan();
  private writeForwardingCompaniesDialogVisible = false;
  private createForwardingCompaniesInvoiceDialogVisible = false;
  private invoiceCompleted = false;
  private forwardingInvoices: InvoiceInfo[] = [];
  private rules = {
    code: [{ required: true, message: "请输入报关合同号", trigger: "blur" }],
    customerId: [{ required: true, message: "请选择客户", trigger: "blur" }],
    shippingOrderId: [
      { required: true, message: "请选择订舱单", trigger: "blur" },
    ],
    currency: [{ required: true, message: "请选择结算货币", trigger: "blur" }],
  };
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    code: null,
    startDate: null,
    endDate: null,
    customerKeyword: null,
    stage: null,
    receiptState: null,
    dateRange: null,
    processStage: null,
  };
  private bookingOrders:any = [];
  private currentRow = {} as any;
  private writeBookingOrderId = "";
  private forwardingCompanies: CompanyData[] = [];
  private forwardingCompanyList: CompanyData[] = [];
  private processStages: BookingOrderProcessStage[] = [];
  private clickROW = { id: "" };
  public diologROW = {} as any;
  public selectRows = [] as any;

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };

  public tableCol = [
    {
      label: "文件名",
      prop: "fileName",
      key: "fileName",
      show: true,
      disabled: false,
      fixed: true,
    },
    {
      label: "上传日期",
      prop: "createdTime",
      key: "createdTime",
      type: "datetime",
      show: true,
      disabled: false,
      fixed: true,
    },
    // {
    //   label: "备注",
    //   prop: "remark",
    //   key: "remark",
    //   type: "remark",
    //   show: true,
    //   disabled: false,
    //   fixed: true
    // }
    {
      label: "操作人",
      prop: "uploader",
      key: "uploader",
      show: true,
      disabled: false,
      fixed: true,
    },
  ];

  created() {
    // this.initSellerList();
    // this.initLogisticsClerkList();
    // this.initShippingList();
    this.initProcessStages();
    this.getList();
  }

  private handleFilter() {
    this.listQuery.pageNumber = 1;
    this.getList();
  }

  private addInvoiceInfos() {
    let sn;
    if (this.forwardingInvoices.length === 0) {
      sn = 1;
    } else {
      sn = this.forwardingInvoices.map(item => item.sn).reduce((max,cur) => Math.max(max, cur)) + 1;
    }
    const invoiceInfo = new InvoiceInfo();
    invoiceInfo.sn = sn;
    this.forwardingInvoices.push(invoiceInfo);
  }

  private isSearchingCustomers = false;
  private customers: ICustomerModel[] = [];

  private searchCustomers(a) {
    this.isSearchingCustomers = true;
    searchCustomer({ keyword: a })
      .then((res: any) => {
        this.customers = res;
        this.isSearchingCustomers = false;
      })
      .catch(() => {
        this.isSearchingCustomers = false;
      });
  }

  private warningPrompt(info, index, charge: number) {
    if (isNaN(charge)) {
    }
  }

  private isLoadingShippingOrders = false;
  private shippingOrders: ShippingOrderModel[] = [];

  private async showUpdateForwardiingCompanyDialog(id: string) {
    this.initCompanyTypes();
    this.writeBookingOrderId = id;
    const data_: any = await getForwardingCompanies(id);
    let data: CompanyData[] = [];
    for (let i = 0; i < data_.length; i++) {
      const forwardingCompanies: any = data_[i];
      data.push(
        new CompanyData(
          forwardingCompanies.id,
          forwardingCompanies.name,
          forwardingCompanies.abbreviation,
          forwardingCompanies.type.name
        )
      );
    }
    this.forwardingCompanies = data;
    this.writeForwardingCompaniesDialogVisible = true;
  }

  private async deleteForwardingCompanies(item: CompanyData) {
    this.forwardingCompanies = this.forwardingCompanies.filter(
      (x) => x !== item
    );
    if (item.id !== undefined) {
      await deleteForwardingCompanies(item.id);
    }
  }

  private deleteForwardingCompanyInvoice(index) {
    this.forwardingInvoices.splice(index, 1);
  }

  private canEditSpecialCharges = true;

  private async showCreateForwardingCompaniesInvoiceDialog(
    id: string,
    edit: boolean
  ) {
    this.canEditSpecialCharges = edit;
    this.writeBookingOrderId = id;
    const data: any = await getForwardingCompanies(id);
    this.forwardingCompanyList = data;
    const data_: any = await queryForwardingCompaniesInvoiceById(id);
    this.forwardingInvoices = data_;
    await this.getAllSpecialChargeTypes();
    this.createForwardingCompaniesInvoiceDialogVisible = true;
  }

  private async createForwardingCompaniesInvoice() {
    const data = {
      invoiceInfos: this.forwardingInvoices,
      completed: this.invoiceCompleted,
    };
    await createForwardingCompaniesInvoice(this.writeBookingOrderId, data);
    this.$message({
      message: "添加成功！",
      type: "success",
    });
    this.createForwardingCompaniesInvoiceDialogVisible = false;
    this.writeBookingOrderId = "";
  }

  private closeForwardingCompaniesDialog() {
    this.invoiceCompleted = false;
    this.createForwardingCompaniesInvoiceDialogVisible = false;
  }

  private async downloadInvoice(row: BookingOrderTableRowData) {
    await downloadInvoiceTemplate(row.id);
    // const res: any = await getExcelUrl(row.id);
    // doDownload(res);
  }

  private async handleUpdateForwardingCompanies() {
    await updateForwardingCompanies(this.writeBookingOrderId, {
      forwardingCompanies: this.forwardingCompanies,
    });
    this.$message({
      message: "添加成功！",
      type: "success",
    });
    this.writeForwardingCompaniesDialogVisible = false;
    await this.getList();
  }

  private async handleEditDeadlineDate(row: BookingOrderTableRowData) {
    if (!row.newDeadlineDate) {
      Message.error({ message: "请选择日期", duration: 2000 });
      return;
    }
    await updateDeadlineDate(row.id, row.newDeadlineDate);
    row.isEditDeadlineDatePopoverVisible = false;
    row.newDeadlineDate = null;
    await this.getList();
  }

  private async handleEditSailingSchedule(row: BookingOrderTableRowData) {
    if (!row.newSailingSchedule) {
      Message.error({ message: "请选择日期", duration: 2000 });
      return;
    }
    await updateSailingSchedule(row.id, row.newSailingSchedule);
    row.isEditSailingSchedulePopoverVisible = false;
    row.newSailingSchedule = null;
    await this.getList();
  }

  private async getList() {
    this.listLoading = true;
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    }
    const params = { ...this.listQuery,type:"LOGISTICS_PAGE" };
    params.dateRange = null;
    const { content, total }: any = await searchBookingOrderForLogistics(
      params
    );
    this.bookingOrders = content.map((value) => {
      return {
        ...value,
        isEditDeadlineDatePopoverVisible: false,
        isEditSailingSchedulePopoverVisible: false,
        newDeadlineDate: value.deadlineDate,
        newSailingSchedule: value.sailingSchedule,
      };
    });
    this.bookingOrders.map((item,index) => {item.sn = index + 1});
    console.log(this.bookingOrders);
    this.total = total;
    this.listLoading = false;
  }

  private companyTypes: CompanyType[] = [];

  private initCompanyTypes() {
    this.companyTypes = [];
    this.companyTypes.push(new CompanyType("SELF", "自拉自报"));
    this.companyTypes.push(new CompanyType("APPOINTED", "指定货代"));
    this.companyTypes.push(new CompanyType("OTHER", "其他类型"));
  }

  private async initSellerList() {
    const data: any = await getUsersByJobPosition(this.JobPositionType.seller);
    this.sellerList = data;
  }

  private async initProcessStages() {
    const data: any = await listProcessStages();
    this.processStages = data;
  }

  private async initLogisticsClerkList() {
    const data: any = await getUsersByJobPosition(
      this.JobPositionType.logisticsClerk
    );
    this.logisticsClerkList = data;
  }

  private curRowId ="";

  /**
   * 清关资料dialog打开
   * @param row
   * @constructor
   * @private
   */
  private async QingGuanZiLiao(row) {
    this.QingGuanZiLiaoShow = true;
    this.curRowId = row.id;
  }

  // private async initShippingList() {
  //   const data: any = await getShipping(true);
  //   this.shippingOrderList = data;
  // }
  private declarationInfo: DeclarationInfo = new DeclarationInfo(
    defaultCustomerData,
    new DeclarationCharge()
  );

  // 是否展示确认报关信息按钮
  private showDeclarationInfo(row) {
    return row.processStage && row.processStage.canSeeDeclarationInfo;
  }

  private canEditDeclarationInfo(row) {
    return row.processStage && row.processStage.canConfirmDeclarationInfo;
  }

  private confirmDeclarationInfoDialogVisible = false; // 确认报关信息
  private editDeclarationInfo = false;

  private showConfirmDeclarationInfoDialog(row) {
    this.currentRow = row;
    this.editDeclarationInfo = this.canEditDeclarationInfo(row);
    this.confirmDeclarationInfoDialogVisible = true;
  }

  private declarationInfoConfirm() {
    this.confirmDeclarationInfoDialogVisible = false;
    this.getList();
  }

  // 添加报关单据
  private addLoadingPlanListDialogVisible = false;
  // 已选中的报关单据
  private loadingPlanList: LoadingPlanList = new LoadingPlanList();
  private loadingPlanFilter: LoadingPlanFilter = new LoadingPlanFilter();
  private loadingPlans: LoadingPlanListTableRowData[] = [];

  private addFile(file: File) {
    // this.files = [file];
    const isLimit = file.size / 1024 / 1024 < 10;
    if (!isLimit) {
      this.$message.error(`上传文件大小不能超过10MB!`);
      return;
    }
    this.files.push(file);
  }

  private async handleUpload() {
    let formData = new window.FormData();
    formData.append("files", this.files.pop());
    this.uploadJieKou(formData);
  }

  private async uploadJieKou(formData) {
    await uploadDocuments(this.clickROW.id, formData);
    this.$notify({
      title: "成功",
      message: "上传成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private uploadDoc(row) {
    this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
    this.clickROW = row;
  }

  // 保存下载舱单信息修改
  private async saveShippingOrder() {
    let list = [];
    this.containerLoadingInfos.forEach((item, index) => {
      list.push(
        (
          this.$refs[`shippingOrderContainer${index}`][0] as Vue & {
            data_: Object;
          }
        ).data_
      );
    });

    const containerTypes = list.map((value) => {
      return {
        containerTypeId: value.containerTypeId,
        containerNumber: value.containerNumber,
        sealNumber: value.sealNumber,
        weight: value.weight,
      };
    });
    await saveContainerType({
      containerTypeRequestList: containerTypes,
    });
    this.showCheck = false;
  }

  /**
   * 下载舱单信息
   */
  private async downloadShippingOrder(row: BookingOrderTableRowData) {
    await downloadShippingOrder(row.id);
  }

  private merges1 = [];
  private filterVal1 = [];
  private tableDatas1 = [];
  private multiHeader1 = [];
  private styles1 = [];

  /**
   * 下载客户PL
   * @param row
   * @private
   */
  private async downloadCustomerPackingList(row: BookingOrderTableRowData) {
    const res: any = await getCustomerPackingList(row.id);
    const {
      customerContainerTypes,
      tel,
      name,
      address,
      customerInvoiceNumber,
      currencyUnit,
      createdAt,
      ivCompanyOtherInfo
    } = res;
    let list = await this.dealData(customerContainerTypes);
    let list_merges = await this.dealMerges(customerContainerTypes);
    let list_styles = await this.dealStyles(list);
    const t1 = row.code.split("").length > 0 && row.code.split("")[0] === 'B'?["WENZHOU HUAQIANG AUTO PARTS CO.,LTD."]:["WENZHOU JIARUI INDUSTRIAL CO.,LTD."];
    // const t1 = ["WENZHOU HUAQIANG AUTO PARTS CO.,LTD."];
    const t2 = [
      "ADD: NO. 40, LIMING INDUSTRIAL ZONE, LUCHENG DISTRICT, WENZHOU, CHINA",
    ];
    const t3 = ["TEL: ( 86)-577-86066017       FAX:  (86)-577-86066515"];
    const t4 = ["PACKING LIST"];
    const t5 = ["TO:", "", "", "", "", "", "", "", "", ""];
    const t6 = [
      name,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "PACKING LIST NO:",
      customerInvoiceNumber,
    ];
    const t7 = [`${address}\n${tel}`, "", "", "", "", "", "", "", "CURRENCY:", currencyUnit];
    const t8 = ["", "", "", "", "", "", "", "", "DATE:", createdAt];
    const t9 = ["", "", "", "", "", "", "", "", "FROM", ""];
    const t10 = ["", "", "", "", "", "", "", "", "", ""];
    const t11 = ["", "", "", "", "", "", "", "", "", ""];
    const t12 = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "次包装信息",
      "",
      "",
      "",
      "",
      "",
      "",
      "其它信息",
    ];
    const t13 = [
      "S/N",
      "Customer No.",
      "H&Q No.",
      "OE No.",
      "REF No.",
      "Product name",
      "PO No.",
      "QTY",
      "QTY/PKG",
      "PKG",
      "PKG NO.",
      "G.W.",
      "N.W.",
      "VOL.",
      "PALLET SIZE",
      "",
      "",
      "CARTON NUMBER",
      "CARTON CODE",
      "CARTONS SIZE",
      "",
      "",
      "G.W.",
      "N.W.",
      "HS NO.",
      "外箱平均重量（托装）",
      "",
      "产品重量",
      "",
      "产品平均重量",
      "",
      "产品属性1",
      "产品属性2",
      "产品属性3",
      "产品属性4",
      "产品品牌",
      "订单拆分",
    ];
    const t14 = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "(PCS)",
      "(PKG)",
      "(PKG)",
      "",
      "(KG)",
      "(KG)",
      "(CBM)",
      "Lenght",
      "width",
      "height",
      "(PCS)",
      "",
      "Lenght",
      "width",
      "height",
      "(KG)",
      "(KG)",
      "",
      "G.W.",
      "N.W.",
      "G.W.",
      "N.W.",
      "G.W./PKG",
      "N.W./PKG",
    ];
    let multiHeader = [
      t2,
      t3,
      t4,
      t5,
      t6,
      t7,
      t8,
      t9,
      t10,
      t11,
      t12,
      t13,
      t14,
      ...list,
    ];
    const merges = [
      "A1:N1",
      "A2:N2",
      "A3:N3",
      "A4:N4",
      "A6:H6",
      "A7:H9",
      "L6:N6",
      "L7:N7",
      "L8:N8",
      "L9:N9",
      "A10:H10",
      "A11:H11",
      "R12:W12",
      "Y12:AE12",
      "O13:Q13",
      "S13:S14",
      "T13:V13",
      "A13:A14",
      "B13:B14",
      "C13:C14",
      "D13:D14",
      "E13:E14",
      "F13:F14",
      "G13:G14",
      "K13:K14",
      "Y13:Y14",
      "Z13:AA13",
      "AB13:AC13",
      "AD13:AE13",
      ...list_merges,
    ];
    const filename = `客户PL-${row.customerAbbr}`;
    const filterVal = [];
    const tableDatas = [];
    let styles = [...list_styles];
    //注意：组装的导出excel所需要的数据结构
    const excelDatas = [
      {
        header: t1,
        filterVal,
        tableDatas,
        merges,
        multiHeader,
        styles,
        sheetName: "Sheet1", // 表一的sheet名字
      },
    ];
    //   引入的函数
    this.json2excel(excelDatas, filename);
  }

  private async dealData(data: CustomerContainerTypes[]) {
    let newData = deepClone(data);
    let arr = [];
    let allTotal1 = 0;
    let allTotal2 = 0;
    let allTotal3 = 0;
    let allTotal4 = 0;
    let allTotal5 = 0;
    let ctnQuantity = 0;
    let pltQuantity = 0;
    let unit = "CTNS.";
    newData.map((item) => {
      let total1 = 0;
      let total2 = 0;
      let total3 = 0;
      let total4 = 0;
      let total5 = 0;
      let customsPackingInfo = new SimpleCustomsPackingInfoData();
      // 20GP     箱号/封号
      customsPackingInfo.title = `${item.name} ${item.containerNumber}/${item.sealNumber}`;
      customsPackingInfo.customsPackingSet = item.customsPackingSet;
      customsPackingInfo.items = [];
      item.customsPackingSet.map((val) => {
        if (val.code.indexOf("CTN") > -1) {
          ctnQuantity = ctnQuantity + 1;
        } else {
          pltQuantity = pltQuantity + 1;
        }
        total2 = total2 + val.packingQuantity;
        total3 = total3 + val.grossWeight;
        total4 = total4 + val.netWeight;
        total5 = total5 + val.customsPackingVolume;
        val.secondaryPackings.forEach((p_val) => {
          let packingQuantity = this.calSinglePackingProductQty(
            val.packingQuantity,
            p_val.product.totalNumberPcs
          );
          customsPackingInfo.items.push([
            p_val.product.guestModel,
            p_val.product.hqOrJrNumber,
            p_val.product.oeNumber,
            p_val.product.refNumber,
            p_val.product.englishName,
            p_val.product.poNumber,
            // 主包装箱数合并如CTNOA#1-5，则取产品总数量
            // val.packingQuantity > 1 ? val.productQuantity : p_val.product.totalNumberPcs,
            this.calSinglePackingProductQty(
              val.packingQuantity,
              p_val.product.totalNumberPcs
            ),
            val.productQuantity / val.packingQuantity,
            val.packingQuantity,
            val.code,
            val.grossWeight,
            val.netWeight,
            val.customsPackingVolume,
            val.packingVolume.length,
            val.packingVolume.width,
            val.packingVolume.height,
            p_val.cartonNumber,
            p_val.cartonCode,
            p_val.packingVolume.length,
            p_val.packingVolume.width,
            p_val.packingVolume.height,
            p_val.grossWeight == "0" ? "" : p_val.grossWeight,
            p_val.netWeight == "0" ? "" : p_val.netWeight,
            p_val.product.hsNumber,
            val.avgGrossWeight,
            val.avgNetWeight,
            p_val.product.avgGrossWeightDescription,
            p_val.product.avgNetWeightDescription,
            p_val.product.grossWeight,
            p_val.product.netWeight,
            p_val.product.productAttribute1,
            p_val.product.productAttribute2,
            p_val.product.productAttribute3,
            p_val.product.productAttribute4,
            p_val.product.brandName,
            p_val.product.purchaseOrderGroup,
          ]);
          total1 = total1 + packingQuantity;
        });
      });
      allTotal1 = allTotal1 + total1;
      allTotal2 = allTotal2 + total2;
      allTotal3 = allTotal3 + total3;
      allTotal4 = allTotal4 + total4;
      allTotal5 = allTotal5 + total5;
      if (ctnQuantity !== 0 && pltQuantity !== 0) {
        unit = "PKGS.";
      } else if (pltQuantity !== 0) {
        unit = "PLTS.";
      }
      arr.push(customsPackingInfo);
    });
    let list = [];
    arr.forEach((arrItem) => {
      arrItem.items.map((item, index) => {
        item.unshift(index + 1);
      });
      list = [...list, [arrItem.title]];
      list = [...list, ...[...arrItem.items]];
    });
    list.push(
      [
        "",
        "TOTAL",
        "",
        "",
        "",
        "",
        "",
        allTotal1,
        "",
        allTotal2,
        "",
        allTotal3,
        allTotal4,
        allTotal5,
      ],
      [""],
      ["REMARKS"],
      ["1.TOTAL ORDER QUANTITY IS " + allTotal1 + "PCS AUTO PARTS ."],
      ["2.TOTAL ORDER PACKAGES ARE " + allTotal2 + unit]
    );

    Message.warning({
      message: "次包装数据（全部或部分）缺失，由系统自动生成，请验证后使用",
      duration: 4000,
    });
    return list;
  }

  private calSinglePackingProductQty(
    packingQuantity,
    totalNumberPcs
  ) {
    if (packingQuantity === 1) {
      return totalNumberPcs;
    } else {
      return totalNumberPcs * packingQuantity
    }
  }

  private async dealMerges(data: CustomerContainerTypes[]) {
    let newData = deepClone(data);
    let arr = [];
    let startNum = 15;
    newData.map((item, index) => {
      let merges = [];
      let productNum = 0;
      let goodsSize = 0;
      merges.push(`A${startNum}:AE${startNum}`);
      item.customsPackingSet.map((val, index) => {
        let leftNum = 0;
        let rigthNum = 0;
        // 有多个次包装就需要合并
        if (val.secondaryPackings.length > 0) {
          goodsSize += val.secondaryPackings.length;
          leftNum = startNum + goodsSize - val.secondaryPackings.length + 1;
          rigthNum = startNum + goodsSize;
        } else {
          leftNum++;
          rigthNum++;
        }
        productNum += val.secondaryPackings.length;
        // 合并主包装
        let letter = ["I", "J", "K", "L", "M", "N", "O", "P", "Q"];
        let letterMerges = letter.map((letterItem) => {
          return `${letterItem}${leftNum}:${letterItem}${rigthNum}`;
        });
        merges = [...merges, ...letterMerges];
      });
      // 柜型，箱号封号合并单元格
      startNum = productNum + startNum + 1;
      arr.push(...merges);
    });
    arr.push("A" + (startNum + 2) + ":B" + (startNum + 2));
    arr.push("A" + (startNum + 3) + ":F" + (startNum + 3));
    arr.push("A" + (startNum + 4) + ":E" + (startNum + 4));
    return arr;
  }

  private async dealStyles(data: any) {
    const commonStyle = {
      font: {
        name: "Times New Roman",
        sz: 11,
        color: { rgb: "#333333" },
        bold: true,
        italic: false,
        underline: false,
      },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true, //自动换行
      },
    };
    const letter = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "AA",
      "AB",
      "AC",
      "AD",
      "AE",
      "AF",
      "AG",
      "AH",
      "AI",
      "AJ",
    ];
    let list = [];
    for (let y = 0; y < letter.length; y++) {
      for (let i = 0; i < 18 + data.length; i++) {
        list.push({
          key: `${letter[y]}${i + 1}`,
          value: commonStyle,
        });
      }
    }
    list = [
      ...list,
      {
        key: "A1",
        value: {
          font: {
            name: "Times New Roman",
            sz: 20,
            color: { rgb: "#333333" },
            bold: true,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        },
      },
      {
        key: "A4",
        value: {
          font: {
            name: "Times New Roman",
            sz: 20,
            color: { rgb: "#333333" },
            bold: true,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        },
      },
      {
        key: "A6",
        value: {
          font: {
            name: "Times New Roman",
            sz: 11,
            color: { rgb: "#333333" },
            bold: true,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "A7",
        value: {
          font: {
            name: "Times New Roman",
            sz: 11,
            color: { rgb: "#333333" },
            bold: true,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
            wrapText: true, //自动换行
          },
        },
      },
      {
        key: "A10",
        value: {
          font: {
            name: "Times New Roman",
            sz: 11,
            color: { rgb: "#333333" },
            bold: true,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "A11",
        value: {
          font: {
            name: "Times New Roman",
            sz: 11,
            color: { rgb: "#333333" },
            bold: true,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
    ];
    return list;
  }

  // tableJson 导出数据 ;
  private json2excel(tableJson: any, filename: string) {
    //这个是引用插件
    import("@/utils/excel").then((excel) => {
      const header = [];
      const data = [];
      const sheetname = [];
      const merges = [];
      const styles = [];
      const multiHeader = [];
      for (let i in tableJson) {
        header.push(tableJson[i].header);
        data.push(formatJson(tableJson[i].filterVal, tableJson[i].tableDatas));
        sheetname.push(tableJson[i].sheetName);
        merges.push(tableJson[i].merges);
        multiHeader.push(tableJson[i].multiHeader);
        styles.push(tableJson[i].styles);
      }
      excel.exportJson3Excel(
        header,
        data,
        sheetname,
        filename,
        multiHeader,
        merges,
        false,
        styles
      );
    });
  }

  private removeSelectedDeclarationDocument() {
    (
      this.$refs.selectedDeclarationDocumentTable as DeclarationDocumentTable
    ).selection.forEach((value) => (value.select = false));
  }

  private addSelectedDeclarationDocument() {
    const selection: LoadingPlanListTableRowData[] = (
      this.$refs.availableLoadingPlanList as DeclarationDocumentTable
    ).selection;
    selection.forEach((value) => (value.select = true));
  }

  private async handleAddLoadingPlanList(confirm: boolean) {
    const selectedLoadingPlans = this.loadingPlans
      .filter((value) => value.select)
      .map((value) => {
        return { id: value.id, loadingPlanType: value.type };
      });
    const data: any = {
      bookingOrderId: this.currentRow.id,
      confirm,
      loadingPlans: selectedLoadingPlans,
    };
    if (this.loadingPlanList.id) {
      await updateLoadingPlanList(this.loadingPlanList.id, data);
    } else {
      await createLoadingPlanList(data);
    }
    this.addLoadingPlanListDialogVisible = false;
    await this.getList();
  }

  //查看下载舱单信息
  private showCheck = false;

  private showShippingOrder(row: BookingOrderTableRowData) {
    this.currentRow = row;
    this.queryLoadingPlanListDetail(this.currentRow.loadingPlanListId);
    this.showCheck = true;
  }

  //查看报关单据详情
  private showDetail = false;
  private customsInfo: CustomsInfo = new CustomsInfo();
  private curRowProcessStage = "";

  private async showCustomsDetails(row: BookingOrderTableRowData) {
    this.listLoading = true;
    const data: any = await getCustomsDetails(row.id);
    this.customsInfo = data;
    this.curRowProcessStage = row.processStage.name
    this.showDetail = true;
    this.listLoading = false;
  }

  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "BOOKING_ORDER", documentId: data.id },
    });
  }

  private loadingPlanListDetail: LoadingPlanListDetailResponse =
    new LoadingPlanListDetailResponse();
  private containerLoadingInfos: ContainerLoadingInfoData[] = [];

  private async queryLoadingPlanListDetail(loadingPlanListId: string) {
    const data: any = await getLoadingPlanListDetail(loadingPlanListId);
    this.loadingPlanListDetail = data;
    this.containerLoadingInfos = data.loadingInfos.map((value) => {
      const containerLoadingInfo: ContainerLoadingInfoData = { ...value };
      containerLoadingInfo.type = value.loadingPlanType;
      containerLoadingInfo.loadingPlans = value.loadingPlans.map(
        (loadingPlan) => {
          const loadingPlanInfo = new LoadingPlanInfo();
          loadingPlanInfo.id = loadingPlan.id;
          loadingPlanInfo.type = loadingPlan.loadingPlanType;
          loadingPlanInfo.code = loadingPlan.loadingPlanCode;
          loadingPlanInfo.customsPackingInfos = loadingPlan.customsPackingSet;
          return loadingPlanInfo;
        }
      );
      return containerLoadingInfo;
    });
  }

  // 查看/登记 货代费用
  private forwardingChargeDialogVisible = false;
  private forwardingChargeInfos: ForwardingChargeInfo[] = [];
  private allSpecialChargeTypes: ForwardingChargeType[] = [];

  private async getAllSpecialChargeTypes() {
    if (this.allSpecialChargeTypes.length < 1) {
      const data: any = await listSpecialChargeTypes();
      this.allSpecialChargeTypes = data;
    }
  }

  private addForwardingCharge(value: any) {
    let sn;
    if (value.forwardingCharges.length === 0) {
      sn = 1;
    } else {
      sn = value.forwardingCharges.map(item => item.sn).reduce((max, cur) => Math.max(max, cur)) + 1;
    }
    const c = new ChargeInfo();
    c.sn = sn;
    value.forwardingCharges.push(c);
  }

  // 报关
  private async handleDeclare(row: BookingOrderTableRowData) {
    await declare(row.id);
    await this.getList();
  }

  // 导出excel
  private isExporting = false;

  private exportExcel() {
    this.isExporting = true;
    const data = this.bookingOrders.map((value) => {
      return {
        declarationStateDesc:
          value.declarationState && value.declarationState.desc,
        processStageDesc: value.processStage && value.processStage.desc,
        forwardingCompanyNames: value.forwardingCompanies
          .map((value) => value.name)
          .join(","),
        formattedCreatedDate: timeParser(value.createdAt),
        formattedDeadlineDate: timeParser(value.deadlineDate),
        formattedSailingSchedule: timeParser(value.sailingSchedule),
        ...value,
      };
    });
    const headers = [
      "报关合同号",
      "创建日期",
      "截单日期",
      "申报日期",
      "货代",
      "报关状态",
      "销售员",
      "客户简称",
      "处理阶段",
    ];
    const fieldNames = [
      "code",
      "formattedCreatedDate",
      "formattedDeadlineDate",
      "formattedSailingSchedule",
      "forwardingCompanyNames",
      "declarationStateDesc",
      "sellerName",
      "customerAbbr",
      "processStageDesc",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `报关合同（销售）-${new Date()}`
    );
    this.isExporting = false;
  }

  private invoiceAudit() {
    (this.$refs["forwardCompanyInvoiceAuditRef"] as ForwardCompanyInvoiceAudit).openDialog();
  }

  private renderCusAbbr(prop, row) {
    if (row.pcNames && row.pcNames.length > 0){
      return `[${row.pcNames}]${prop}`
    }
    return prop
  }
    private addRemarkDialogVisible = false;

  private listRemark = {
    bookingOrderId: null,
    remark: null
  };

  private showAddRemarkDialog(row) {
    this.listRemark = {
      bookingOrderId: row.id,
      remark: row.remark
    };
    this.addRemarkDialogVisible = true;
  }

  private async doAddRemark() {
    await updateBookingOrder(
        this.listRemark.bookingOrderId, {
          remark: this.listRemark.remark,
          type: "LOGISTICS_PAGE"
        }
    );
    this.addRemarkDialogVisible = false;
    await this.getList();
  }
}

class BookingOrderTableRowData {
  id: string;
  code: string;
  customerAbbr: string;
  customerId: string;
  shippingOrderId: string;
  shippingOrderCode: string;
  currencyUnit: string;
  receiptDate: string;
  deadlineDate: string;
  sailingSchedule: string;
  invoiceId: string;
  invoiceCode: string;
  useInvoiceMoney: boolean;
  invoiceMoney: string;
  loadingPlanListId: string;
  declarationState: DeclarationState;
  processStage: BookingOrderProcessStage;
  forwardingCompanies: Company[];
  sellerName: string;
  createdAt: string;

  //for edit
  newDeadlineDate: string;
  newSailingSchedule: string;
  isEditDeadlineDatePopoverVisible = false;
  isEditSailingSchedulePopoverVisible = false;
  isConfirmReceiptPopoverVisible = false;
}

class DeclarationInfo {
  customer: ICustomerModel;
  declarationCharge: DeclarationCharge;

  constructor(customer: ICustomerModel, declarationCharge: DeclarationCharge) {
    this.customer = customer;
    this.declarationCharge = declarationCharge;
  }
}

class CompanyData {
  id: string;
  name: string;
  abbreviation: string;
  type: string;

  constructor(id: string, name: string, abbreviation: string, type: string) {
    this.id = id;
    this.name = name;
    this.abbreviation = abbreviation;
    this.type = type;
  }
}

class DeclarationCharge {
  id: string;
  bookingOrderId: string;
  freight: string;
  insurance: string;
  extras: string;
}

class WriteBookingOrderRequest {
  id: string = null;
  code: string = null;
  customerId: string = null;
  shippingOrderId: string = null;
  currencyUnit: string = null;
  forwardingCompanies: Company[] = [];
}

class LoadingPlanList {
  id: string;
  bookingOrderId: string;
  bookingOrderCode: string;
  customerAbbr: string;
  customerCode: string;
  loadingPlans: LoadingPlan[];
  unusedLoadingPlans: LoadingPlan[];
}

class LoadingPlan {
  id: string;
  loadingPlanType: LoadingPlanType;
  code: string;
  createdAt: string;
  category: string;
  factoryNames: string;
  containerTypeInfos: string[];
  totalPCS: number;
  totalAmount: string;
  volumes: string;
  customerId: string;
  customsPackingSet?: CustomsPackingModel[];
}

class LoadingPlanFilter {
  code: string;
  category: string;
  factoryName: string;
}

class LoadingPlanListDetailResponse {
  id: string;
  bookingOrderCode: string;
  customerAbbr: string;
  shippingOrderCode: string;
  billLadingCode: string;
  forwardingCompanies: Company[];
  loadingInfos: LoadingPlan[];
}

export class LoadingPlanType {
  name: string;
  desc: string;
}

class ForwardingChargeInfo {
  bookingCharge: number;
  terminalHandlingCharge: number;
  trailerCharge: number;
  forwardingCompanyId: string;
  forwardingCompanyName: string;
  invoiceCode: string;
  paymentDate: string;
  forwardingCompanyType: CompanyType;
  specialCharges: ForwardingCharge[] = [];
}

class InvoiceInfo {
  id: string;
  sn: number;
  name: string;
  type: string;
  forwardingCompanyId: string;
  typeOfCurrency: string;
  invoiceCode: string;
  paymentDate: string;
  remark: string;
  forwardingCharges: ChargeInfo[] = [];
}

class ChargeInfo {
  sn: number;
  typeName: string;
  charge: string;
}

/**
 * 主包装信息
 */
class SimpleCustomsPackingInfoData {
  title: string;
  items: any;
  customsPackingSet: CustomsPackingModel[] = [];
}

class CustomerContainerTypes {
  code: string;
  containerNumber: string;
  customsPackingSet: CustomsPackingModel[] = [];
  id: string;
  loadingInOneOrMorePlaces: boolean;
  name: string;
  packingQuantity: number;
  productQuantity: number;
  sealNumber: string;
}

class CustomsPackingModel {
  id: string;
  code: CustomsPackingCode;
  hqPackingListId: string;
  hqPackingListCode: string;
  packingVolume: PackingVolume;
  netWeight: number;
  grossWeight: number;
  packingQuantity: number;
  customsPackingVolume: number;
  productQuantity: number;
  state: State;
  ackType: string;
  loadingFirst: boolean;
  createdAt: Date;
  factoryName?: string;
  problemType?: ProblemType;
  secondaryPackings: SecondaryPackingModel[] = [];
  avgNetWeight: number;
  avgGrossWeight: number;
}

class SecondaryPackingModel {
  grossWeight: number;
  netWeight: number;
  packingVolume: PackingVolume;
  product: ProductInfoModel;
}

class ProductInfoModel {
  declarationDescription: string;
  description: string;
  englishName: string;
  guestModel: string;
  hqOrJrNumber: any;
  hsNumber: string;
  id: string;
  nameWithModel: string;
  oeNumber: string;
  packingNumberPcs: number;
  poNumber: any;
  refNumber: string;
  totalNumberPcs: number;
  avgGrossWeightDescription: number;
  avgNetWeightDescription: number;
  grossWeight: number;
  netWeight: number;
}
